
import '../scss/pfields/Pcaptcha.scoped.scss';
import { ReCAPTCHA } from "react-google-recaptcha";
import { createRef } from "react";

function Pcaptcha ({pfield}) {
  const recaptchaRef = createRef();
  const sitekey = pfield.obj.querySelector(".g-recaptcha").getAttribute("data-sitekey");
  const grecaptchaObject = window.grecaptcha;
  const pCapTextarea = pfield.obj.querySelector("textarea");
  const cId = 'c' + crypto.randomUUID().replaceAll('-','');
  const onChange = (value) => {
    console.log(`We have ${value}`);
    pCapTextarea.value = value;
  }
  return (
    <div className="dcaptcha">
    <ReCAPTCHA 
      ref={recaptchaRef}
      //ref={(r) => this.recaptcha = r}
      id={cId}
      isolated={true}
      sitekey={sitekey}
      onChange={onChange}
      grecaptcha={grecaptchaObject}
      size="normal"
    />
    </div>
  );
}

export default Pcaptcha;